import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { QUERY_shiftCardFetchOrder } from 'queries';
import { ShiftCardFetchOrderQuery } from 'types/graphql';

export const fetchOrderQueryConfig = (
  orderId: number,
): UseGQLQueryConfig<ShiftCardFetchOrderQuery, ShiftCardFetchOrderQuery, { orderId: number }> => ({
  key: 'FETCH_ORDER_QUERY',
  query: QUERY_shiftCardFetchOrder,
  variables: {
    orderId,
  },
});
